import posthog from 'posthog-js'

// Telemetry must never get in the way of the app: without a key it is not started at all, and on a local development host session recording (the
// /s/ endpoint that failed on CORS from http://localhost:3000) is not started, so a blocked analytics request cannot add noise or wait on anything.
// Events and page views are sent asynchronously by the PostHog library and nothing in the app awaits them.
const isLocalHost = () => ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);

export const initPostHog = () => {
  if (typeof window === 'undefined') return;
  const key = process.env.REACT_APP_POSTHOG_KEY;
  if (!key) {
    console.info('[PostHog] not started: REACT_APP_POSTHOG_KEY is not set');
    return;
  }
  try {
    posthog.init(key, {
      disable_session_recording: isLocalHost(),
      api_host: process.env.REACT_APP_POSTHOG_HOST,
      person_profiles: 'identified_only',
      capture_pageview: false, // We'll handle this manually
      capture_pageleave: true,
      // Session recordings configuration
      session_recording: {
        maskAllInputs: true, // Mask all input fields for privacy
        maskInputOptions: {
          password: true,
          email: true,
        },
        blockClass: 'ph-no-capture', // Don't record elements with this class
        ignoreClass: 'ph-ignore', // Ignore elements with this class
      },
      // Auto-capture configuration
      autocapture: {
        dom_event_allowlist: ['click', 'change', 'submit'],
        url_allowlist: ['.*'], // Allow all URLs
        element_allowlist: ['a', 'button', 'form', 'input', 'select', 'textarea'],
      },
    });
  } catch (error) {
    console.warn('[PostHog] could not start; the app continues without analytics:', error);
  }
};

export { posthog }